import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faCheckDouble, faShieldAlt } from '@fortawesome/free-solid-svg-icons';

/**
 * TurneroResetPassword - Component to set new password using token
 */
const TurneroResetPassword = ({ token, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        password: '',
        repeatPassword: ''
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (formData.password !== formData.repeatPassword) {
            Notify({ type: 'fail', text: 'Las contraseñas no coinciden' });
            return;
        }

        if (formData.password.length < 6) {
            Notify({ type: 'fail', text: 'La contraseña debe tener al menos 6 caracteres' });
            return;
        }

        setLoading(true);

        const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/';

        request.Post(API_BASE + 'turnero/reset-password', { 
            token, 
            password: formData.password 
        }, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Contraseña actualizada correctamente' });
                if (onSuccess) onSuccess();
            } else {
                Notify({ type: 'fail', text: r.msg || 'Error al restablecer la contraseña' });
            }
            setLoading(false);
        }, 'json', err => {
            Notify({ type: 'fail', text: 'Error de conexión' });
            setLoading(false);
        });
    };

    return (
        <div className="w-100">
            <h1 className="auth-title">Nueva Contraseña</h1>
            <p className="auth-subtitle">Define tu nueva clave de acceso para asegurar tu cuenta.</p>

            <form onSubmit={handleSubmit}>
                <div className="auth-input-group">
                    <input
                        type="password"
                        className="auth-input"
                        placeholder="Nueva contraseña"
                        value={formData.password}
                        onChange={e => setFormData({ ...formData, password: e.target.value })}
                        required
                    />
                    <FontAwesomeIcon icon={faLock} className="auth-input-icon" />
                </div>

                <div className="auth-input-group mb-4">
                    <input
                        type="password"
                        className="auth-input"
                        placeholder="Repetir nueva contraseña"
                        value={formData.repeatPassword}
                        onChange={e => setFormData({ ...formData, repeatPassword: e.target.value })}
                        required
                    />
                    <FontAwesomeIcon icon={faCheckDouble} className="auth-input-icon" />
                </div>

                <button type="submit" className="auth-btn-primary mb-4" disabled={loading}>
                    {loading ? <Spinner size="sm" animation="border" /> : (
                        <><FontAwesomeIcon icon={faShieldAlt} /> Actualizar Contraseña</>
                    )}
                </button>

                <div className="p-3 bg-glass-dark border-radius-12 mt-2">
                    <ul className="text-white m-0 p-0" style={{ opacity: 0.6, fontSize: '0.8rem', listStyle: 'none' }}>
                        <li>• Mínimo 6 caracteres</li>
                        <li>• Combina letras y números</li>
                    </ul>
                </div>
            </form>
        </div>
    );
};

export default TurneroResetPassword;
